import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import PortfolioGrid from '../components/sections/PortfolioGrid';
import CompanyIntro from '../components/sections/CompanyIntro';
import VideoGallery from '../components/sections/VideoGallery';
import ContactCTA from '../components/sections/ContactCTA';
import SEO from '../components/SEO';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Home"
        description="Datasignz CreativeMinds is a full-service creative studio in Paramaribo delivering video production, post-production, on-air identity, marketing & branding, and web services."
        keywords="video production, post-production, on-air identity, marketing, branding, web services, Suriname, Paramaribo, creative agency"
        canonical="/"
      />
      <Header />
      <PortfolioGrid />
      <CompanyIntro />
      <VideoGallery />
      <ContactCTA />
      <Footer />
    </div>
  );
};

export default HomePage;
